// @ts-ignore
import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";
import { UserLocale } from "src/utils/useGeoCurrency";

import FeatureGates from "@atlaskit/feature-gate-js-client";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { IntercomProvider } from "@/libraries/intercom/src/provider";
import { JiraSoftwarePricingPageV2Template } from "@/templates/software/jira/pricing/src/jira-software-pricing-page-v2.template";
import { experiments } from "@/utils/experiment/manifest";
import { useExperimentExposure } from "@/utils/experiment/use-experiment-exposure";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql";

import { AppPricingData } from "../../../../contentful/product-catalog";

export type JiraSoftwarePricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const JiraSoftwarePricingPage = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: JiraSoftwarePricingPageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    const [hasFired, fireExposure] = useExperimentExposure(
        experiments.jiraPricingWaeMigrationExperimentRerunExp
    );
    useEffect(() => {
        if (!hasFired) {
            fireExposure();
        }
    }, [hasFired, fireExposure]);

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <PricingContentContextProvider
                productId="jira-software"
                pricingContent={pricingContent}
                queryRef={queryRef}
            >
                <div>
                    <JiraSoftwarePricingPageV2Template
                        pricing={pricing}
                        countryCode={countryCode}
                    />
                </div>
            </PricingContentContextProvider>
        </IntercomProvider>
    );
};
